const data = [
    {id: 1, link: '/', title: 'Home'},
    {id: 2, link: '/Services', title: 'Services'},
    {id: 2, link: '/Contact', title: 'Contact'},
]

export default data;